import React, { useEffect, useState } from 'react';
import { useCompany } from '../../context/CompanyContext';

import ErrorBoundary from '../../components/ErrorBoundary';
import { useAuth } from '../../context/AuthContext';
import { showSuccess, showError } from '../../utils/toastHelper';

function CompanySelector() {
  const { activeCompany, companies, loading, fetchCompanies, setActiveCompanyById } = useCompany();
  const { user } = useAuth();
  const [changingCompany, setChangingCompany] = useState(false);

  useEffect(() => {
    try {
      fetchCompanies();
    } catch (error) {
      console.error('Şirket listesi yüklenirken hata:', error);
      showError('Şirketler yüklenemedi');
    }
  }, []);

  const handleCompanyChange = async (companyId) => {
    if (changingCompany) return; // İşlem devam ediyorsa çift tıklamayı engelle

    try {
      setChangingCompany(true);
      showSuccess('Şirket değiştiriliyor, lütfen bekleyin...');

      const success = await setActiveCompanyById(companyId);
      if (success) {
        // Başarılı mesajı zaten setActiveCompanyById içinde gösterilecek
        // Sayfa yenilenecek
      } else {
        showError('Şirket değiştirilemedi');
      }
    } catch (error) {
      console.error('Şirket değiştirme hatası:', error);
      showError('Beklenmeyen bir hata oluştu');
    } finally {
      setChangingCompany(false);
    }
  };

  if (loading || changingCompany) {
    return (
      <div className="company-selector d-flex align-items-center">
        <div className="spinner-border spinner-border-sm text-orange" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </div>
        {changingCompany && <span className="ms-2 small">Şirket değiştiriliyor...</span>}
      </div>
    );
  }

  if (user?.role !== 'SUPER_ADMIN') {
    return null;
  }

  return (
    <ErrorBoundary>
      <div className="company-selector d-flex align-items-center">
        <select
          className="form-select form-select-sm border-0 bg-light"
          value={activeCompany?.id || (user?.companyId ? user.companyId.toString() : '')}
          onChange={(e) => handleCompanyChange(e.target.value)}
          style={{ maxWidth: '200px' }}
          disabled={changingCompany}
        >
          {companies && companies.length > 0 ? (
            companies.map(company => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))
          ) : (
            <option value="">Şirket bulunamadı</option>
          )}
        </select>
      </div>
    </ErrorBoundary>
  );
}

export default CompanySelector; 